import { VehicleImageWithMeta } from '@/catalog/types/vehicle';
import { createImageUrl } from '@/catalog/utils/pdp/create-image-url';

export interface FindImagesByCategoryOptions {
  /** Optional image type to filter by in addition to category */
  imageType?: string;
  /** Optional limit for number of images to return */
  limit?: number;
  /** CDN URL for creating image URLs */
  cdnUrl: string;
}

/**
 * Finds images by category and optionally by type, with support for limiting results
 * @param images Array of vehicle images to search through
 * @param category Category to filter by
 * @param options Additional options for filtering and limiting results
 * @returns Array of image URLs matching the criteria
 */
export function findImagesByCategory(
  images: VehicleImageWithMeta[],
  category: string,
  options: FindImagesByCategoryOptions
): string[] {
  const filteredImages = images.filter((image) => {
    const matchesCategory = image.image_category === category;
    // If no image type is provided match any type, otherwise match the provided type
    const matchesType = !options.imageType || image.image_type === options.imageType;
    return matchesCategory && matchesType;
  });

  const limitedImages = options.limit
    ? filteredImages.slice(0, options.limit)
    : filteredImages;

  return limitedImages.map((image) => createImageUrl(options.cdnUrl, image));
}
